import React from 'react';

export function Lineup() {
  return <></>;
}
